<template>
  <div style="display: inline;">
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/production/wo/page" getKey="rows" :columns="columns"  @selectionChange="selectionChange">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('shengchangongdanhao')">
            <el-input v-model="yt.conditions.no"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shebeimingcheng')">
            <yi_data_select :multiple="true" :type="'equipment'" :ids.sync="yt.conditions.equipmentIdList"></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('chanpinmingcheng')">
            <yi_data_select :multiple="true" :type="'material2'" :ids.sync="yt.conditions.materialIdList"></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('chuangjianshijian')">
            <yi_time_input :format="'yyyy-MM-dd HH:mm:ss'" type="datetimerange" ref="yiTime" :start.sync="yt.conditions.createTimeStart" :end.sync="yt.conditions.createTimeEnd"></yi_time_input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain>
              {{ $t('sousuo') }}
            </el-button>
          </el-form-item>
          <yi_curd_expand_button></yi_curd_expand_button>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button v-if="utils.checkPower('web_production_management_work_order_execution_batch_close')" style="margin-left: 10px;" size="mini" @click="closePlan" type="primary">
          {{ $t('guanbi') }}
        </el-button>
      </template>
    </yi_curd_table>
  </div>
</template>

<script>
export default {
  name: 'web_production_management_work_order_execution_batch_close',
  data() {
    return {
      ids: [],
      conditions: {
        statusList: [2,4],
        parentId: 0,
      },
      columns: [
        {
          label: 'xuanze',
          type: 'selection',
        },
        {
          label: 'shengchangongdanhao',
          prop: 'no',
          sort: 'string',
          width: 200
        },
        {
          label: 'ERPgongdanhao',
          prop: 'erpNo',
          sort: 'string',
          width: 130
        },
        {
          label: 'gongdanzhuangtai',
          type: 'tag',
          sort: 'string',
          prop: 'status',
          width: 130,
          tags: {
            1: {
              color: '#419FFF',
              text: this.$t('xinjian')
            },
            2: {
              color: '#419FFF',
              text: this.$t('fafang')
            },
            3: {
              color: '#67C23A',
              text: this.$t('shengchanzhong')
            },
            4: {
              color: '#F56C6C',
              text: this.$t('zanting')
            },
            5: {
              color: '#67C23A',
              text: this.$t('shougongxuwangong')
            },
            6: {
              color: '#67C23A',
              text: this.$t('wangong')
            },
            7: {
              color: '#909399',
              text: this.$t('guanbi')
            },
            8: {
              color: '#E6A23C',
              text: this.$t('yidiaobo')
            }
          }
        },
        {
          label: 'shebeimingcheng',
          prop: 'equipment.name',
          sort: 'string',
          width: 130
        },
        {
          label: 'mujubianhao',
          prop: 'mould.no',
          sort: 'string',
          width: 130
        },
        {
          label: 'mujumingcheng',
          prop: 'mould.name',
          sort: 'string',
          width: 130
        },
        {
          label: 'chanpinbianma',
          prop: 'material.code',
          sort: 'string',
          width: 130
        },
        {
          label: 'chanpinmingcheng',
          prop: 'material.name',
          sort: 'string',
          width: 130
        },
        {
          label: 'jihuashuliang',
          prop: 'planQuantity',
          sort: 'number'
        },
        {
          label: 'yibaogongliangpinshu',
          prop: 'finishGoodQuantity',
          width: 130
        },
        {
          label: 'chuangjianshijian',
          prop: 'createTime',
          type: 'time',
          width: 180
        },
      ]
    }
  },
  created() {
    setTimeout(() => {
      this.$set(this.yt, 'conditions', this.utils.copy(this.conditions));
      this.yt.get(1);
    }, 300);
  },
  methods: {
    selectionChange(items) {
      this.ids = items.map(item => {
        return item.id;
      });
    },
    closePlan() {
      if (this.ids.length > 0) {
        this.$confirm(this.$t('shiofouguanbi?'), this.$t('guanbiqueren'), {
          confirmButtonText: this.$t('queding'),
          cancelButtonText: this.$t('quxiao'),
          type: 'warning'
        }).then(() => {
          this.http.post('/web/production/wo/batchClose', { ids:this.ids}).then(res => {
            this.yt.get(1);
          });
        }).catch((e) => {
          console.log(e)
        });
      }else {
        this.$message.error(this.$t('print_record_cannot_empty'));
      }
    },
  },
}
</script>
<style scoped lang="scss">

</style>